/* tslint:disable */
/* eslint-disable */
/**
 * TOM YARD SERVICE API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { Configuration } from '../configuration'
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios'
import globalAxios from 'axios'
// Some imports not used depending on template conditions
// @ts-ignore
import {
  DUMMY_BASE_URL,
  assertParamExists,
  setApiKeyToObject,
  setBasicAuthToObject,
  setBearerAuthToObject,
  setOAuthToObject,
  setSearchParams,
  serializeDataIfNeeded,
  toPathString,
  createRequestFunction,
  replaceWithSerializableTypeIfNeeded,
} from '../common'
// @ts-ignore
import {
  BASE_PATH,
  COLLECTION_FORMATS,
  type RequestArgs,
  BaseAPI,
  RequiredError,
  operationServerMap,
} from '../base'
// @ts-ignore
import type { CreateRoadSegmentRequest } from '../model'
// @ts-ignore
import type { CreateRoadSegmentResponse } from '../model'
// @ts-ignore
import type { DeleteRoadSegmentRequest } from '../model'
// @ts-ignore
import type { GetRoadSegmentsResponse } from '../model'
// @ts-ignore
import type { UpdateRoadSegmentRequest } from '../model'
/**
 * RoadSegmentsApi - axios parameter creator
 */
export const RoadSegmentsApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @param {CreateRoadSegmentRequest} [createRoadSegmentRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createRoadSegment: async (
      createRoadSegmentRequest?: CreateRoadSegmentRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/yard/api/RoadSegments`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Bearer required
      // oauth required
      await setOAuthToObject(localVarHeaderParameter, 'Bearer', [], configuration)

      localVarHeaderParameter['Content-Type'] = 'application/json'
      localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        createRoadSegmentRequest,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @param {DeleteRoadSegmentRequest} [deleteRoadSegmentRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteRoadSegment: async (
      deleteRoadSegmentRequest?: DeleteRoadSegmentRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/yard/api/RoadSegments`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Bearer required
      // oauth required
      await setOAuthToObject(localVarHeaderParameter, 'Bearer', [], configuration)

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        deleteRoadSegmentRequest,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getRoadSegments: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
      const localVarPath = `/yard/api/RoadSegments`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Bearer required
      // oauth required
      await setOAuthToObject(localVarHeaderParameter, 'Bearer', [], configuration)

      localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @param {UpdateRoadSegmentRequest} [updateRoadSegmentRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateRoadSegment: async (
      updateRoadSegmentRequest?: UpdateRoadSegmentRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/yard/api/RoadSegments`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Bearer required
      // oauth required
      await setOAuthToObject(localVarHeaderParameter, 'Bearer', [], configuration)

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        updateRoadSegmentRequest,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
  }
}

/**
 * RoadSegmentsApi - functional programming interface
 */
export const RoadSegmentsApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = RoadSegmentsApiAxiosParamCreator(configuration)
  return {
    /**
     *
     * @param {CreateRoadSegmentRequest} [createRoadSegmentRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async createRoadSegment(
      createRoadSegmentRequest?: CreateRoadSegmentRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateRoadSegmentResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.createRoadSegment(
        createRoadSegmentRequest,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['RoadSegmentsApi.createRoadSegment']?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @param {DeleteRoadSegmentRequest} [deleteRoadSegmentRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async deleteRoadSegment(
      deleteRoadSegmentRequest?: DeleteRoadSegmentRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.deleteRoadSegment(
        deleteRoadSegmentRequest,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['RoadSegmentsApi.deleteRoadSegment']?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getRoadSegments(
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetRoadSegmentsResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getRoadSegments(options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['RoadSegmentsApi.getRoadSegments']?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @param {UpdateRoadSegmentRequest} [updateRoadSegmentRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async updateRoadSegment(
      updateRoadSegmentRequest?: UpdateRoadSegmentRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.updateRoadSegment(
        updateRoadSegmentRequest,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['RoadSegmentsApi.updateRoadSegment']?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
  }
}

/**
 * RoadSegmentsApi - factory interface
 */
export const RoadSegmentsApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = RoadSegmentsApiFp(configuration)
  return {
    /**
     *
     * @param {CreateRoadSegmentRequest} [createRoadSegmentRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createRoadSegment(
      createRoadSegmentRequest?: CreateRoadSegmentRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<CreateRoadSegmentResponse> {
      return localVarFp
        .createRoadSegment(createRoadSegmentRequest, options)
        .then(request => request(axios, basePath))
    },
    /**
     *
     * @param {DeleteRoadSegmentRequest} [deleteRoadSegmentRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteRoadSegment(
      deleteRoadSegmentRequest?: DeleteRoadSegmentRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<void> {
      return localVarFp
        .deleteRoadSegment(deleteRoadSegmentRequest, options)
        .then(request => request(axios, basePath))
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getRoadSegments(options?: RawAxiosRequestConfig): AxiosPromise<GetRoadSegmentsResponse> {
      return localVarFp.getRoadSegments(options).then(request => request(axios, basePath))
    },
    /**
     *
     * @param {UpdateRoadSegmentRequest} [updateRoadSegmentRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateRoadSegment(
      updateRoadSegmentRequest?: UpdateRoadSegmentRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<void> {
      return localVarFp
        .updateRoadSegment(updateRoadSegmentRequest, options)
        .then(request => request(axios, basePath))
    },
  }
}

/**
 * RoadSegmentsApi - object-oriented interface
 */
export class RoadSegmentsApi extends BaseAPI {
  /**
   *
   * @param {CreateRoadSegmentRequest} [createRoadSegmentRequest]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public createRoadSegment(
    createRoadSegmentRequest?: CreateRoadSegmentRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return RoadSegmentsApiFp(this.configuration)
      .createRoadSegment(createRoadSegmentRequest, options)
      .then(request => request(this.axios, this.basePath))
  }

  /**
   *
   * @param {DeleteRoadSegmentRequest} [deleteRoadSegmentRequest]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public deleteRoadSegment(
    deleteRoadSegmentRequest?: DeleteRoadSegmentRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return RoadSegmentsApiFp(this.configuration)
      .deleteRoadSegment(deleteRoadSegmentRequest, options)
      .then(request => request(this.axios, this.basePath))
  }

  /**
   *
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public getRoadSegments(options?: RawAxiosRequestConfig) {
    return RoadSegmentsApiFp(this.configuration)
      .getRoadSegments(options)
      .then(request => request(this.axios, this.basePath))
  }

  /**
   *
   * @param {UpdateRoadSegmentRequest} [updateRoadSegmentRequest]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public updateRoadSegment(
    updateRoadSegmentRequest?: UpdateRoadSegmentRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return RoadSegmentsApiFp(this.configuration)
      .updateRoadSegment(updateRoadSegmentRequest, options)
      .then(request => request(this.axios, this.basePath))
  }
}
